import { useState } from 'react';
import { useMediaQuery } from '@monofront/business/hooks';
import FooterDesktop from '../FooterDesktop';
import { useLayoutContext } from '@context/LayoutContext';
import { useRouter } from 'next/router';
import { useAuthentication } from '@context/businessContainer';
import CompleteRegistration from '@components/CompleteRegistration';
import useDocumentScrollThrottled from '@hooks/layout/useDocumentScrollThrottled';
import SmallCenteredText from '@components/SmallCenteredText';
import { useLayoutRefs } from '@context/layoutRefs';
import { isMobileApp } from '@utils/environment';

const legalNoticeUrls = ['/search', '/collections'];

const Footer = () => {
  const { headerContainerRef } = useLayoutRefs();
  const { isMember } = useAuthentication();
  const isMobile = useMediaQuery(800);
  const { legalNotice } = useLayoutContext();
  const { pathname } = useRouter();
  const [hasCompleteRegistrationButton, setHasCompleteRegistrationButton] =
    useState(false);

  useDocumentScrollThrottled(
    ({ isMinimumScrolled }) => {
      if (pathname === '/home') {
        setHasCompleteRegistrationButton(isMinimumScrolled);
      }
    },
    headerContainerRef,
    250,
    300,
    !isMember && isMobile,
  );

  if (isMobileApp) return null;

  return (
    <>
      {legalNotice &&
        legalNotice.length > 0 &&
        legalNoticeUrls.some((url) => pathname.startsWith(url)) && (
          <div className="legal">
            <SmallCenteredText text={legalNotice} />{' '}
          </div>
        )}
      <FooterDesktop />
      {hasCompleteRegistrationButton && pathname === '/home' && (
        <>
          <div className="complete-registration">
            <CompleteRegistration />
          </div>
          <div className="complete-registration-placeholder" />
        </>
      )}
      <style jsx>{`
        .complete-registration {
          position: fixed;
          left: var(--space-4);
          bottom: var(--space-4);
          z-index: 300;
          animation: slideUp 0.5s;
        }

        .complete-registration-placeholder {
          height: 45px;
        }

        .legal {
          padding: 0 var(--padding-layout-horizontal-sm);
        }

        .legal > :global(div) {
          margin-top: 0;
        }

        @keyframes slideUp {
          from {
            opacity: 0.3;
            transform: translateY(80px);
          }

          to {
            opacity: 1;
            transform: translateY(0px);
          }
        }
      `}</style>
    </>
  );
};

export default Footer;
